const Menu = function(){

    
    const scrollHeader = function (el) {

        let headerH = $(el).height();
        if( $(window).scrollTop() > headerH / 2 ){
            if(!$(el).hasClass('opened'))
            {
                $("#webdoor-start").addClass('upWebdoor');
                $(el).addClass('scrolling');
            }
        } else{
            $("#webdoor-start").removeClass('upWebdoor');
            $(el).removeClass('scrolling');
        }
    }

    const toggleMenu = function (el) {

        let header = $("#header");

        if($(el).attr('id') != 'wrap-sandwitch') {
            el = "#wrap-sandwitch";
        }
        $(el).toggleClass("motion-in");
        $(el).closest('header').toggleClass("header-opened").find('nav').toggleClass("motion-in");

        // menu mobile
        $("#menu-mob").toggleClass('active');
        $("#nav-icon3").toggleClass('open');
   
        if(header.hasClass("header-opened")){
            $('.header-logo').fadeOut(100);
            $('html,body').toggleClass('no-scroll');
        }else{
            $('.header-logo').fadeIn(100);
            $('html,body').removeClass('no-scroll');
        }

    }


    return {
        init : function () {

            const navMenu = $("#wrap-nav-links");

            // tratativa hover do menu 'black'
            if( $('header').hasClass('header-black') ) {
                navMenu.find('.nav-link').on('mouseenter',function(){
                    navMenu.find('.nav-link:not(:hover)').find('p').css('color','black');
                }).on('mouseleave',function(){
                    navMenu.find('.nav-link.actived').find('p').css('color','white');
                })
            }

            navMenu.find('.nav-link').on('mouseenter', function(){

                let leftEl = $(this).position().left;
                navMenu.find('.bg-nav-link').stop(true).animate({
                    left : leftEl,
                    opacity : 1
                },450,'swing');

            }).on('mouseleave', function(){

                let leftEl = navMenu.find('.nav-link').hasClass('actived') ? navMenu.find('.nav-link.actived').position().left : $(this).position().left;
                navMenu.find('.bg-nav-link').animate({
                    left : leftEl,
                    opacity : navMenu.find('.bg-nav-link').hasClass('home-actived') ? 0 : 1
                },450,'swing');

            })

            scrollHeader("#header");

            $(window).on('scroll', function(){
                scrollHeader("#header");
            });

            $("#wrap-sandwitch, #nav-header a:not(.act-link)").on("click", function(){
                toggleMenu(this);
            });

        }
    }

}();

module.exports = Menu;